import ProgressBar from 'components/ProgressBar';
import React from 'react';

import { RepositoryStatus } from '../types';

type RepoStatusBarProps = {
  status: RepositoryStatus;
};

const RepoStatusBar: React.FC<RepoStatusBarProps> = ({ status }) => {
  // Convert value to percentage
  const getValue = (): number => {
    switch (status) {
      case RepositoryStatus.Connected:
        return 0; // Example value for Connected status
      case RepositoryStatus.Scheduled:
        return 0.05; // Example value for Scheduled status
      case RepositoryStatus.ScanInitiated:
        return 0.1; // Example value for ScanInitiated status
      case RepositoryStatus.Scanning:
        return 0.2; // Example value for Scanning status
      case RepositoryStatus.PartiallyScanned:
        return 0.3; // Example value for PartiallyScanned status
      case RepositoryStatus.ScanCompleted:
        return 0.4; // Example value for ScanCompleted status
      case RepositoryStatus.AnalyzingResults:
        return 0.6; // Example value for AnalyzingResults status
      case RepositoryStatus.AwaitingSync:
        return 0.6; // Example value for AwaitingSync status
      case RepositoryStatus.Syncing:
        return 0.8; // Example value for Syncing status
      case RepositoryStatus.SyncCompleted:
        return 1; // Example value for SyncCompleted status
      case RepositoryStatus.Error:
        return 1; // Example value for Error status
      case RepositoryStatus.TimeoutDelay:
        return 1; // Example value for TimeoutDelay status
      case RepositoryStatus.Deactivated:
        return 1; // Example value for Deactivated status
      case RepositoryStatus.Disconnected:
        return 1; // Example value for Disconnected status
      case RepositoryStatus.Unknown:
        return 1; // Example value for Unknown status
      default:
        return 0;
    }
  };

  // Determine the background color class based on the specified color prop
  const getColor = ():
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'success'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
    | undefined => {
    switch (status) {
      case RepositoryStatus.Connected:
        return 'info'; // Example color for Connected status
      case RepositoryStatus.Scheduled:
      case RepositoryStatus.ScanInitiated:
      case RepositoryStatus.Scanning:
      case RepositoryStatus.PartiallyScanned:
      case RepositoryStatus.ScanCompleted:
      case RepositoryStatus.AwaitingSync:
      case RepositoryStatus.AnalyzingResults:
      case RepositoryStatus.Syncing:
      case RepositoryStatus.SyncCompleted:
        return 'success'; // Example color for SyncCompleted status

      // return "light"; // Example color for SyncCompleted status
      case RepositoryStatus.Error:
      case RepositoryStatus.TimeoutDelay:
        return 'danger'; // Example color for TimeoutDelay status
      case RepositoryStatus.Deactivated:
      case RepositoryStatus.Disconnected:
      case RepositoryStatus.Unknown:
        return 'warning'; // Example color for Unknown status
      default:
        return 'info';
    }
  };

  return (
    <div style={{ minWidth: '130px', maxWidth: '130px' }}>
      <ProgressBar
        value={getValue()}
        label={status.toString()}
        color={getColor()}
      />
    </div>
  );
};

export default RepoStatusBar;
